var map = {
	"./en/hema/custom.json": [
		57350,
		7350
	],
	"./fr/hema/custom.json": [
		48873,
		8873
	],
	"./nl/hema/custom.json": [
		80627,
		627
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 39247;
module.exports = webpackAsyncContext;